import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    isLoaded: { type: Boolean, default: false },
    iframeHtml: String,
  };

  connect() {
    document.addEventListener('embed:load', this.loadEmbed.bind(this));
  }

  notifyIframelyScriptIsLoaded() {
    this.element.dispatchEvent(
      new CustomEvent('embed:load', { bubbles: true })
    );
  }

  loadEmbed(event) {
    event.preventDefault();

    if (this.isLoadedValue) {
      return true;
    }

    if (window.__iframelyLoaded) {
      this.embedIframelyIframe();
      this.isLoadedValue = true;
    } else {
      if (window.__iframelySetup) {
        return true;
      }

      var script = document.createElement('script');
      script.src = `//cdn.iframe.ly/embed.js?key=${window.ENV.iframely.key}`;
      script.async = true;
      script.onload = () => {
        window.__iframelyLoaded = true;
        this.notifyIframelyScriptIsLoaded();
      };
      document.body.appendChild(script);

      window.__iframelySetup = true;
    }
  }

  embedIframelyIframe() {
    this.element.innerHTML = this.iframeHtmlValue;
    this.element.classList.add('article-extras-embed__container--is-loaded');
  }
}
